import { render, staticRenderFns } from "./DecisionCreator.vue?vue&type=template&id=56f60d93&scoped=true&"
import script from "./DecisionCreator.vue?vue&type=script&lang=ts&"
export * from "./DecisionCreator.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionCreator.vue?vue&type=style&index=0&id=56f60d93&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f60d93",
  null
  
)

export default component.exports